import * as React from "react";
import { IIconBase } from "./IconBase";

export const InProgressIcon = ({ ...props }: IIconBase) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.99967 19.1663C15.0623 19.1663 19.1663 15.0623 19.1663 9.99967C19.1663 4.93706 15.0623 0.833008 9.99967 0.833008C4.93706 0.833008 0.833008 4.93706 0.833008 9.99967C0.833008 15.0623 4.93706 19.1663 9.99967 19.1663Z" stroke="#FFC400" stroke-width="2"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M4.16602 13.949L9.68204 9.99967V3.33301C13.463 3.33301 16.528 6.31778 16.528 9.99967C16.528 13.6816 13.463 16.6663 9.68204 16.6663C7.41898 16.6663 5.4124 15.597 4.16602 13.949Z" fill="#FFC400"/>
  </svg>
);
